import { render, staticRenderFns } from "./MessageCell.vue?vue&type=template&id=0d648790&scoped=true&"
import script from "./MessageCell.vue?vue&type=script&lang=js&"
export * from "./MessageCell.vue?vue&type=script&lang=js&"
import style0 from "./MessageCell.vue?vue&type=style&index=0&id=0d648790&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d648790",
  null
  
)

export default component.exports